// Première connexion / connexion par code (OTP email). Logique pure, testée.
// Parcours : email → Supabase envoie un code à 6 chiffres (compte existant uniquement) →
// le client le recopie → session → écran de choix (Google / mot de passe / plus tard).

export const RESEND_COOLDOWN_S = 60; // cadence Supabase par défaut entre deux envois au même email

export function normalizeEmail(s: string): string {
  return (s || '').trim().toLowerCase();
}

export function isValidOtpCode(s: string): boolean {
  return /^\d{6}$/.test((s || '').replace(/\s+/g, ''));
}

export function cleanOtpCode(s: string): string {
  return (s || '').replace(/\s+/g, '');
}

export function otpErrorMessage(err: { message?: string; code?: string } | null | undefined): string {
  const m = err?.message || '';
  const c = err?.code || '';
  if (!m && !c) return "Une erreur s'est produite. Réessaie.";
  if (/signups? not allowed/i.test(m)) {
    return "Cet email n'a pas d'accès Hook. Vérifie l'adresse, ou demande une invitation à ton interlocuteur Hook.";
  }
  const after = m.match(/after (\d+) second/i);
  if (after) return `Un code vient déjà d'être envoyé. Réessaie dans ${after[1]} secondes.`;
  if (c === 'over_email_send_rate_limit' || /rate limit/i.test(m)) {
    return 'Trop de demandes de code pour le moment. Attends quelques minutes puis réessaie.';
  }
  if (c === 'otp_expired' || /expired|invalid/i.test(m)) {
    return 'Code incorrect ou expiré. Vérifie les 6 chiffres, ou demande un nouveau code.';
  }
  return m;
}

/** Secondes restantes avant de pouvoir redemander un code. */
export function resendDelayLeft(lastSentAtMs: number | null, nowMs: number): number {
  if (!lastSentAtMs) return 0;
  const left = RESEND_COOLDOWN_S - Math.floor((nowMs - lastSentAtMs) / 1000);
  return left > 0 ? left : 0;
}
